import { cn } from '@jk-core/utils';
import { CalendarView } from '@/Calendar/type';
import styles from './ViewSelector.module.scss';

interface ViewSelectorProps {
  method: CalendarView;
  selectView: (value: CalendarView) => void;
}
export default function ViewSelector({ method, selectView }:ViewSelectorProps) {
  return (
    <div className={styles.view}>
      <div className={
        cn({
          [styles.view__block]: true,
          [styles['view__block--second']]: method === 'month',
          [styles['view__block--last']]: method === 'year',
        })
      }
      />
      <button
        className={cn({
          [styles.view__selector]: true,
          [styles['view__selector--selected']]: method === 'day',
        })}
        type="button"
        onClick={() => selectView('day')}
      >일
      </button>
      <button
        className={cn({
          [styles.view__selector]: true,
          [styles['view__selector--selected']]: method === 'month',
        })}
        type="button"
        onClick={() => selectView('month')}
      >월
      </button>
      <button
        className={cn({
          [styles.view__selector]: true,
          [styles['view__selector--selected']]: method === 'year',
        })}
        type="button"
        onClick={() => selectView('year')}
      >년
      </button>
    </div>
  );
}
